module.exports = __webpack_public_path__ + "img/portrait.537051d4.svg";